// This file is abstrcted so it can be mocekd for testing

export const defaultFeatureConfig = () => ({ features: {}, organisations: {} });
